/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

function announcementFunctions(){
  var x = [];
  var index = [];
  //console.log('announcementFunctions');
      $('[data-section-type="announcement-bar"]').each(function(){
        
        var parent = $(this);
        var time = parent.data('time');

        if($(this).data('layout') == 'slideshow'){
  //console.log('announcementFunctions layout slideshow');
          var maxWidth = 1000000;
        }
        else{
          var maxWidth = 768;
        }
        
        if($(window).width() > maxWidth){
        
          clearInterval(x[parent.attr('id')]);

          $(window).resize(function(){
            announcementFunctions();
          })
        }
        else{
      index[parent.attr('id')] = 1;
          
       x[parent.attr('id')] = setInterval(function(){
        console.log('changing the announcement');
          index[parent.attr('id')]++;
          
          if(parent.find('.AnnouncementBar__Content[data-index="'+index[parent.attr('id')]+'"]').length == 0){
            
           index[parent.attr('id')] = 1;
          }
          
           parent.find('.AnnouncementBar__Content:not([data-index="'+index[parent.attr('id')]+'"])').slideUp(300);
            parent.find('.AnnouncementBar__Content[data-index="'+index[parent.attr('id')]+'"]').slideDown(300);
          
        }, time)
        }
      })
}

  function customModalShow(cookie, modal){
    console.log('modalClass: ' + modal.attr('class').replace(/\s/g, ''));
    if(cookie == 'cookie'){
     
      if(checkCookie(modal.attr('class').replace(/\s/g, '')) == 1){
       console.log('customModalShow('+cookie+'); opened: opened');
        
        return 'opened';
        
        
      }
      else{
        setCookie(modal.attr('class').replace(/\s/g, ''));
        
        hideScroll();
        
        fadeEffects('',modal);
        
           console.log('customModalShow('+cookie+'); opened: opening');
        
        
        $('.modal__close').click(function(){
        closeModal(modal);
        })
        console.log('customModalShow('+cookie+');opened: opening');
        
        return 'opening';
        
        
      }
      
    }
    else{
      
      hideScroll();
        
        fadeEffects('',modal);
        
           console.log('customModalShow('+cookie+');opened: opening');
        
        
        $('.modal__close').click(function(){
        closeModal(modal);
        })
        console.log('customModalShow('+cookie+'); opened: opening');
        
        return 'opening';
        
        
      
    }
    
  }
  
  function closeModal(elem){
   fadeEffects(elem, ''); 
    showScroll();
  }

function checkForAttr(attr) {
        if (typeof attr !== typeof undefined && attr !== false) {
            var result = 1;
        } else {
            var result = 0;
        }
  return result;
  
  console.log('checkForAttr('+attr+'); result: ' + result);
  
    }

function quickAddToCart(elem){

    var variantId = elem.attr('data-id');

    var formData = new FormData();
    
 formData.append('form_type', 'product');
 formData.append('utf8', '✓');
 formData.append('id', variantId);

    console.log(formData.entries());
    $.ajax({
        type: "POST",
        url: '/cart/add',
      processData: false, contentType: false,
        data: formData, // serializes the form's elements.
        success: function (data) {
          console.log("we made it!");
          document.documentElement.dispatchEvent(
            new CustomEvent("product:added", {
              bubbles: true,
              detail: {
                quantity: 1
              }
            })
          );
          
        }
      });
  
}

function vertScrollFunctions(){

function adjustArrows(wrapper){
  var parent = wrapper.find('.scroll-area');
       var parentHeight = parent.outerHeight();
       var parentScrollHeight = parent[0].scrollHeight;
       var parentScrollTop = parent.scrollTop();

  if(parentScrollTop == 0){
    wrapper.removeClass('mid-position').removeClass('end-position');
  }
  else if(parentScrollHeight <= parentHeight + parentScrollTop){
    wrapper.removeClass('mid-position').addClass('end-position');
  }
  else{
    wrapper.addClass('mid-position').removeClass('end-position');
  }
}
  
  $(document).on('click', '.vert-scroll-holder .scroll-arrow',function(){
    var arrow = $(this);
     var wrapper = arrow.parents('.vert-scroll-holder');
       var parent = wrapper.find('.scroll-area');
       var parentHeight = parent.outerHeight();
       var parentScrollHeight = parent[0].scrollHeight;
       var parentScrollTop = Math.round(parent.scrollTop());

    console.log('parentHeight: ', parentHeight, '; parentScrollHeight: ', parentScrollHeight, '; parentScrollTop: ', parentScrollTop);

    if(arrow.hasClass('scroll-up')){
       parent.animate({scrollTop: parentScrollTop - parentHeight}, 200);
    }
    else{
       parent.animate({scrollTop: parentScrollTop + parentHeight}, 200);
    }

    adjustArrows(wrapper);
  })

  $('.vert-scroll-holder .scroll-area').on('scroll', function(){
    var wrapper = $(this).parents('.vert-scroll-holder');
       var parent = wrapper.find('.scroll-area');
       var parentHeight = parent.outerHeight();
       var parentScrollHeight = parent[0].scrollHeight;
       var parentScrollTop = Math.round(parent.scrollTop());

    console.log('parentHeight: ', parentHeight, '; parentScrollHeight: ', parentScrollHeight, '; parentScrollTop: ', parentScrollTop);

    adjustArrows(wrapper);
  })
}
function horScrollFunctions() {

  function adjustArrows(wrapper) {
    var parent = wrapper.find('.scroll-area');
    var parentWidth = parent.outerWidth();
    var parentScrollWidth = parent[0].scrollWidth;
    var parentScrollLeft = parent.scrollLeft();

    if (parentScrollLeft == 0) {
      wrapper.removeClass('mid-position').removeClass('end-position');
    } else if (parentScrollWidth <= parentWidth + parentScrollLeft) {
      wrapper.removeClass('mid-position').addClass('end-position');
    } else {
      wrapper.addClass('mid-position').removeClass('end-position');
    }
  }

  $(document).on('click', '.horizontal-scroll .scroll-arrow', function () {
    var arrow = $(this);
    var wrapper = arrow.parents('.hor-scroll-holder');
    var parent = wrapper.find('.scroll-area');
    var parentWidth = parent.outerWidth();
    var parentScrollWidth = parent[0].scrollWidth;
    var parentScrollLeft = Math.round(parent.scrollLeft());

    console.log('parentWidth: ', parentWidth, '; parentScrollWidth: ', parentScrollWidth, '; parentScrollLeft: ', parentScrollLeft);

    if (arrow.hasClass('scroll-left')) {
      parent.animate({ scrollLeft: parentScrollLeft - parentWidth }, 200);
    } else {
      parent.animate({ scrollLeft: parentScrollLeft + parentWidth }, 200);
    }

    adjustArrows(wrapper);
  });

  $('.horizontal-scroll .scroll-area').on('scroll', function () {
    var wrapper = $(this).parents('.hor-scroll-holder');
    var parent = wrapper.find('.scroll-area');
    var parentWidth = parent.outerWidth();
    var parentScrollWidth = parent[0].scrollWidth;
    var parentScrollLeft = Math.round(parent.scrollLeft());

    console.log('parentWidth: ', parentWidth, '; parentScrollWidth: ', parentScrollWidth, '; parentScrollLeft: ', parentScrollLeft);

    adjustArrows(wrapper);
  });
}


function fadeEffects(hideElem, showElem){
      
      if(hideElem.length > 0){
  hideElem.fadeOut(300);
    
    setTimeout(function(){
      if(showElem.length > 0){
      showElem.fadeIn(300);
      }
    }, 300)
      }
      else{
        showElem.fadeIn(300);
      }
     console.log('fadeEffects(hideElem, showElem)');
    
}

  var usedHideScroll = 0;
  
    var scrollValue = 0;

    function hideScroll(){
      scrollValue = $(document).scrollTop();
      $('html, body').addClass('no-overflow').css('top', -scrollValue).css('position', 'fixed');
      
      console.log('function hideScroll('+scrollValue+')');
      
      usedHideScroll = 1;
    }
    
       function showScroll(){
         $('html, body').css('position', 'inherit').removeClass('no-overflow').css('top', 0);
         
         $('html, body').animate({
        scrollTop: scrollValue},
        0);
         console.log('function showScroll('+scrollValue+')');
         
         usedHideScroll = 0;
      }
  
  function toggleScroll(){
    if($('html').hasClass('no-overflow')){
      showScroll();
    console.log('toggleScroll(); showing scroll');
    }
    else{
      hideScroll();
    console.log('toggleScroll(); hiding scroll');
    }
    
  }


  async function addToCartWithFile(file) {
    const data = new FormData($('.ProductForm')[0]);
    data.append("properties[_Preview]", file);
console.log('data:', data);
    const result = await fetch("/cart/add.json", {
        method: "POST",
        body: data
    });

    return result.json();
}

async function submitQuickBuyForm(form){

var id = form.find('[name="id"]').val();
        var formData = new FormData();
    console.log('id:', id);
 formData.append('form_type', 'product');
 formData.append('utf8', '✓');
 formData.append('id', id);

  
    $.ajax({
        type: "POST",
        url: '/cart/add',
      processData: false, contentType: false,
        data: formData, // serializes the form's elements.
        success: function (data) {
          console.log("we made it!");

          $('.quick-add-holder').removeClass('show-variants');
          document.documentElement.dispatchEvent(
            new CustomEvent("product:added", {
              bubbles: true, 
              detail: {
                quantity: 1
              }
            })
          );
          
        }
      });
  
    console.log('pausing form submit');
 }

$(document).ready(function(){

 $(window).resize(function(){
          $('html').css('--window-height', $(window).innerHeight() + 'px');
 })
  
  $('.open-configurator').click(function(){
  
    
    customModalShow('no cookie', $('.product-configurator-modal'));
  })
  
  setTimeout(function(){
$('.formScript').each(function(){
  var formHtml = $(this).html();
  $(this).before(formHtml);
  
})
},6000)

if($('.vert-scroll-holder').length > 0){

  vertScrollFunctions();
}

if($('.hor-scroll-holder').length > 0){

  horScrollFunctions();
}

  
  announcementFunctions();

    $(document).on('click', '.quick-add-variant:not(.disabled)', function(e){
    
    e.preventDefault();
    console.log('should add it');
    quickAddToCart($(this));
  })

  $('.ProductForm__AddToCart').click(async function(e){
    e.preventDefault();
    const data = new FormData($('.ProductForm')[0]);

    const result = await fetch("/cart/add.json", {
        method: "POST",
        body: data
    })
  .then(response => {
    let json = response.json();
    if (response.status >= 200 && response.status < 300) {
      
          console.log("we made it!");
          document.documentElement.dispatchEvent(
            new CustomEvent("product:added", {
              bubbles: true,
              detail: {
                quantity: 1
              }
            })
          );
          
        
    }
  })
    
    console.log('pausing form submit');
  })

  $(document).on('click', '.quick-add-show', function(){
    console.log('quick-add-show clicked');
    var form = $(this).parents('.ProductItem').find('.quickAddForm');
    $('.quickAddForm').removeClass('active');
    if(form.find('.SizeSwatchList').length > 0){
    $(this).parents('.ProductItem').find('.quickAddForm').addClass('active');
    }
    else{
      submitQuickBuyForm(form);
    }
  })
  
$(document).on('change', '.ProductItem .customSizeSwatch__Radio', function(){

  $(this).parents('.HorizontalList__Item').siblings().find('label').removeClass('is-active');
  $(this).parents('.HorizontalList__Item').find('label').addClass('is-active');
  var parent = $(this).parents('.ProductItem');
  var productData = JSON.parse(parent.find('[data-product-json]').html());
var newVariantId;
  productVariants = productData.product.variants;
 // console.log('productVariants: ', productVariants);

  for(var i = 0; i < productVariants.length; i++){
    
    var optionValue1  = null;
    var optionValue2  = null;
    var optionValue3  = null;
    if(parent.find('[data-option-index="1"]:checked').length > 0){
      console.log('optionValue1 - 1');
      optionValue1 = parent.find('[data-option-index="1"]:checked').val();
    }
    else if(parent.find('[data-option-index="1"][type="hidden"]').length > 0){
       optionValue1 = parent.find('[data-option-index="1"][type="hidden"]').val();
      console.log('optionValue1 - 2');
    }
    
    if(parent.find('[data-option-index="2"]:checked').length > 0){
      optionValue2 = parent.find('[data-option-index="2"]:checked').val();
      console.log('optionValue2 - 1');
    }
    else if(parent.find('[data-option-index="2"][type="hidden"]').length > 0){
       optionValue2 = parent.find('[data-option-index="2"][type="hidden"]').val();
      console.log('optionValue2 - 2');
    }
    
    if(parent.find('[data-option-index="3"]:checked').length > 0){
      optionValue3 = parent.find('[data-option-index="3"]:checked').val();
      console.log('optionValue3 - 1');
    }
    else if(parent.find('[data-option-index="3"][type="hidden"]').length > 0){
       optionValue3 = parent.find('[data-option-index="3"][type="hidden"]').val();
      console.log('optionValue3 - 2');
    }
    
      console.log('optionValue1: ', optionValue1, '; productVariants[i].option1:', productVariants[i].option1);
      console.log('optionValue2: ', optionValue2, '; productVariants[i].option2:', productVariants[i].option2);
      console.log('optionValue3: ', optionValue3, '; productVariants[i].option3:', productVariants[i].option3);

    if(optionValue1 == productVariants[i].option1 && optionValue2 == productVariants[i].option2 && optionValue3 == productVariants[i].option3){

      newVariantId = productVariants[i].id;
      parent.find('[name="id"]').val(productVariants[i].id);

      console.log('new value: ' + parent.find('[name="id"]').val());
    }
  }

  var selectedOption = parent.find('[name="id"] option[value="'+newVariantId+'"]');
if(selectedOption.length == 0){
    console.log('option not foound: [name="id"] option[value="'+newVariantId+'"]');
    }
    else if(selectedOption.prop('disabled') == true){
    console.log('option is disabled: [name="id"] option[value="'+newVariantId+'"]');
    parent.find('.ProductForm__AddToCart').addClass('disabled').attr('disabled', true);
  }
  else{
    console.log('option available: [name="id"] option[value="'+newVariantId+'"]');
  
    var form = $(this).parents('.ProductItem').find('.quickAddForm');
    submitQuickBuyForm(form);
  }
})
    var clearPayBlockHeight = $('.clearpayBlock square-placement').outerHeight();
  console.log('clearpayBlock height: ', clearPayBlockHeight);
  
  var x = setInterval(function(){
    //console.log('checking');
    if($('.clearpayBlock square-placement').outerHeight() != clearPayBlockHeight){
    console.log('loaded', $('.clearpayBlock square-placement').outerHeight(), clearPayBlockHeight);
      $('.clearpayBlock').addClass('clearPayLoaded');
      clearInterval(x);
    }
  }, 100);

  $('#truncated').on('click', function(){
    $('#truncated').fadeOut(300, function(){ 
      $('#fullDescription').fadeIn(500);
    })
  })

  $('[data-section-type="product"]').on('variant:changed', function(e) {
console.log('varinat changed now!');
    if($(this).find('input[data-type="vat-value"][data-vat-value="yes"]:checked').length > 0){
      $(this).find('input[data-type="vat-value"][data-vat-value="yes"]:checked').parents('.ProductForm__Option').find('.vat-exempt-info').slideDown(300);
    }
    else{
      $(this).find('.vat-exempt-info').slideUp(300);
    }
  })
})